import axios from 'axios';
import { plainToInstance } from 'class-transformer';

import { ApiResponse, Order, OrderDetails } from '../model';
import { CollectionApiResponse } from './../model/CollectionApiResponse';
import { TEMP_EMPTY_FOR_PREVIEW } from './temp-empty-preview';

export class OrderApi {
  static readonly KEY = 'order';

  static async confirm(
    receipt_id: number,
    address: number,
    receipt_type?: 'receipt' | 'free_form_receipt',
  ): Promise<any> {
    const params: {
      receipt_id: number;
      address: number;
      receipt_type?: string;
    } = {
      receipt_id,
      address,
    };

    if (receipt_type) {
      params.receipt_type = receipt_type;
    }

    const { data } = await axios.post('/api/v1/order', undefined, {
      params,
    });

    return data;
  }

  static async getActive(): Promise<OrderDetails[]> {
    if (TEMP_EMPTY_FOR_PREVIEW) return [];
    const { data } = await axios.get<CollectionApiResponse>(
      '/api/v1/client/order/active',
    );

    return plainToInstance(OrderDetails, data.items);
  }

  static async getAll(isClient: boolean, search?: string): Promise<Order[]> {
    if (TEMP_EMPTY_FOR_PREVIEW) return [];
    const { data } = await axios.get<CollectionApiResponse>(
      isClient ? '/api/v1/client/order' : '/api/v1/order',
      {
        params: {
          search,
        },
      },
    );

    return plainToInstance(Order, data.items);
  }

  static async getById(id: number, isClient = false): Promise<OrderDetails> {
    const { data } = await axios.get<ApiResponse>(
      isClient ? `/api/v1/client/order/${id}` : `/api/v1/order/${id}`,
    );

    const raw = data.data ?? {};
    const instance = plainToInstance(OrderDetails, raw);
    const rawOrderItems = (
      raw as { order_items?: unknown[] | Record<string, unknown> }
    ).order_items;
    const asArray = Array.isArray(rawOrderItems)
      ? rawOrderItems
      : rawOrderItems && typeof rawOrderItems === 'object'
      ? Object.values(rawOrderItems)
      : [];
    if (asArray.length > 0) {
      (instance as { items: unknown[] }).items = asArray;
    }
    return instance;
  }

  static async getNotPaid(): Promise<OrderDetails[]> {
    if (TEMP_EMPTY_FOR_PREVIEW) return [];
    const { data } = await axios.get<CollectionApiResponse>(
      '/api/v1/client/order/not_paid',
    );

    return plainToInstance(OrderDetails, data.items);
  }

  static async getHistoryByPatientId(id: string): Promise<Order[]> {
    if (TEMP_EMPTY_FOR_PREVIEW) return [];
    const { data } = await axios.get<CollectionApiResponse>(
      `/api/v1/order/history/${id}`,
    );

    return plainToInstance(Order, data.items);
  }
}
